module.exports = __webpack_public_path__ + "static/img/system-bg.6e40bfc3.png";